import { setContext } from 'apollo-link-context'

import { dataByTypename } from '../../utils/apollo-helpers'
import namespacedStorage from '../../utils/namespaced-storage'
import { REFRESH } from './authentication.graphql'
import { ooV2Auth } from './oov2-auth'
import { REMOVE_LOYALTY_REDEMPTION_FROM_CART } from '../cart/cart.graphql'

export const storage = namespacedStorage('auth')

export const deleteTokens = () => {
  storage.remove('accessToken')
  storage.remove('refreshToken')
  ooV2Auth.deleteTokens()
}

export const setTokens = ({accessToken, refreshToken}) => {
  storage.set('accessToken', accessToken)
  storage.set('refreshToken', refreshToken)
}

export const getAuthLink = () =>
  setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = storage.get('accessToken') || ''
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'toast-customer-access': token
      }
    }
  })

export const refreshToken = async config => {
  const refreshToken = storage.get('refreshToken')
  if (!refreshToken) {
    deleteTokens()
    return null
  }
  try {
    const resp = await config.client.mutate({
      mutation: REFRESH,
      variables: {
        input: { refreshToken }
      }
    })
    const {
      AuthenticationResponse: data,
      RefreshError: error
    } = dataByTypename(resp.data.refresh)

    if (error) {
      deleteTokens()
      return null
    }

    setTokens(data)
    return data
  } catch ({ message }) {
    return null
  }
}

const removeLoyaltyFromCart = async (client, { redemptionGuid, cartGuid }) => {
  const response = await client.mutate({
    mutation: REMOVE_LOYALTY_REDEMPTION_FROM_CART,
    variables: {
      input: {
        cartGuid,
        redemptionGuid
      }
    }
  })

  const { CartOutOfStockError } = dataByTypename(response.data.removeLoyaltyRedemption)

  if (CartOutOfStockError) {
    throw new Error(CartOutOfStockError.message)
  }

  return response
}

export const cleanUpCartData = async (client, { cart }) => {
  if (!cart) return
  if (cart.order.discounts) {
    const redemptionGuid = cart.order.discounts.loyaltyDiscount && cart.order.discounts.loyaltyDiscount.guid
    if (redemptionGuid) {
      await removeLoyaltyFromCart(client, { redemptionGuid, cartGuid: cart.guid })
    }
  }
}
